'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	type: 'STICKY_HEADER',
	name: 'Sticky header',
	allowedSections: ['header'],
	disallowedChildren: [],
	category: 'Header',
	props: [{
		name: 'hideOnScroll',
		label: 'Hide on scroll',
		inputType: 'checkbox',
		default: false
	}]
};